import { ToraxHttp } from './../utils/custom-http.svc';
import { ObjectsListResult } from './../services/objects-list-results';
import { Injectable, EventEmitter } from '@angular/core';

import { Observable } from "rxjs";
import { Assistance } from './assistance/assistance';

@Injectable()

export class AssistancesData {
  private url = 'api/assistances';


  constructor(
    private toraxHttp: ToraxHttp
  ) { }

  delete(id: number) {
    return this.toraxHttp.getDeleteResponse(`${this.url}/delete/${id}`);
  }

  getList(baseQuery: any) {
    return this.toraxHttp.post(`${this.url}/List`, baseQuery);
  }

  get(id: number) {
    return this.toraxHttp.get(`${this.url}/${id || 0}`);
  }

  createAndPrintAssistancesLetters(assistanceIDs) {
    return this.toraxHttp.get(`${this.url}/createAndPrintAssistancesLetters/${assistanceIDs}`);
  }

  createAndPrintAssistanceLetter(assistanceID: number) {
    return this.toraxHttp.get(`${this.url}/createAndPrintAssistanceLetter?assistanceID=${assistanceID}`);
  }

  getEdit(id: number) {
    return this.toraxHttp.get(`${this.url}/${id || 0}/edit`);
  }

  update(assistance: Assistance) {
    return this.toraxHttp.update(this.url, assistance);
  }

  getAdd(contactId: number) {
    return this.toraxHttp.get(`${this.url}/add/${contactId || 0}`);
  }

  recIn(id: number) {
    return this.toraxHttp.recIn(this.url, id);
  }

  public updatedEvent = new EventEmitter<number>();


  private onUpdated(id: number): void {
    if (this.updatedEvent) {
      this.updatedEvent.emit(id);
    }
  }
}
